// Metadata for top 100 GCP Terraform resources
export const gcpTop100Meta: Record<
  string,
  { displayName: string; category: string }
> = {
  // Compute
  google_compute_instance: {
    displayName: "Compute Engine Instance",
    category: "compute",
  },
  google_compute_instance_template: {
    displayName: "Instance Template",
    category: "compute",
  },
  google_compute_instance_group: {
    displayName: "Instance Group",
    category: "compute",
  },
  google_compute_instance_group_manager: {
    displayName: "Managed Instance Group",
    category: "compute",
  },
  google_compute_autoscaler: {
    displayName: "Compute Autoscaler",
    category: "compute",
  },
  google_compute_disk: {
    displayName: "Persistent Disk",
    category: "compute",
  },
  google_compute_snapshot: {
    displayName: "Disk Snapshot",
    category: "compute",
  },
  google_compute_image: {
    displayName: "Compute Image",
    category: "compute",
  },
  google_container_cluster: {
    displayName: "GKE Cluster",
    category: "compute",
  },
  google_container_node_pool: {
    displayName: "GKE Node Pool",
    category: "compute",
  },
  google_cloudfunctions_function: {
    displayName: "Cloud Functions (Gen 1)",
    category: "compute",
  },
  google_cloudfunctions2_function: {
    displayName: "Cloud Functions (Gen 2)",
    category: "compute",
  },
  google_cloud_run_service: {
    displayName: "Cloud Run Service",
    category: "compute",
  },
  google_cloud_run_v2_service: {
    displayName: "Cloud Run v2 Service",
    category: "compute",
  },
  google_app_engine_application: {
    displayName: "App Engine Application",
    category: "compute",
  },
  google_app_engine_standard_app_version: {
    displayName: "App Engine Version",
    category: "compute",
  },

  // Storage
  google_storage_bucket: {
    displayName: "Cloud Storage Bucket",
    category: "storage",
  },
  google_storage_bucket_object: {
    displayName: "Storage Object",
    category: "storage",
  },
  google_storage_bucket_iam_member: {
    displayName: "Storage Bucket IAM Member",
    category: "storage",
  },
  google_storage_bucket_iam_policy: {
    displayName: "Storage Bucket IAM Policy",
    category: "storage",
  },
  google_filestore_instance: {
    displayName: "Filestore Instance",
    category: "storage",
  },
  google_compute_resource_policy: {
    displayName: "Resource Policy",
    category: "storage",
  },

  // Database
  google_sql_database_instance: {
    displayName: "Cloud SQL Instance",
    category: "database",
  },
  google_sql_database: {
    displayName: "Cloud SQL Database",
    category: "database",
  },
  google_sql_user: {
    displayName: "Cloud SQL User",
    category: "database",
  },
  google_bigtable_instance: {
    displayName: "Bigtable Instance",
    category: "database",
  },
  google_bigtable_table: {
    displayName: "Bigtable Table",
    category: "database",
  },
  google_spanner_instance: {
    displayName: "Cloud Spanner Instance",
    category: "database",
  },
  google_spanner_database: {
    displayName: "Cloud Spanner Database",
    category: "database",
  },
  google_firestore_database: {
    displayName: "Firestore Database",
    category: "database",
  },
  google_firestore_document: {
    displayName: "Firestore Document",
    category: "database",
  },
  google_redis_instance: {
    displayName: "Memorystore Redis",
    category: "database",
  },
  google_memcache_instance: {
    displayName: "Memorystore Memcached",
    category: "database",
  },

  // Networking
  google_compute_network: {
    displayName: "VPC Network",
    category: "networking",
  },
  google_compute_subnetwork: {
    displayName: "VPC Subnet",
    category: "networking",
  },
  google_compute_firewall: {
    displayName: "Firewall Rule",
    category: "networking",
  },
  google_compute_router: {
    displayName: "Cloud Router",
    category: "networking",
  },
  google_compute_router_nat: {
    displayName: "Cloud NAT",
    category: "networking",
  },
  google_compute_vpn_gateway: {
    displayName: "VPN Gateway",
    category: "networking",
  },
  google_compute_vpn_tunnel: {
    displayName: "VPN Tunnel",
    category: "networking",
  },
  google_compute_address: {
    displayName: "Compute Address",
    category: "networking",
  },
  google_compute_global_address: {
    displayName: "Global Address",
    category: "networking",
  },
  google_compute_forwarding_rule: {
    displayName: "Forwarding Rule",
    category: "networking",
  },
  google_compute_global_forwarding_rule: {
    displayName: "Global Forwarding Rule",
    category: "networking",
  },
  google_compute_backend_service: {
    displayName: "Backend Service",
    category: "networking",
  },
  google_compute_backend_bucket: {
    displayName: "Backend Bucket",
    category: "networking",
  },
  google_compute_health_check: {
    displayName: "Health Check",
    category: "networking",
  },
  google_compute_http_health_check: {
    displayName: "HTTP Health Check",
    category: "networking",
  },
  google_compute_https_health_check: {
    displayName: "HTTPS Health Check",
    category: "networking",
  },
  google_compute_url_map: {
    displayName: "URL Map",
    category: "networking",
  },
  google_compute_target_http_proxy: {
    displayName: "HTTP Proxy",
    category: "networking",
  },
  google_compute_target_https_proxy: {
    displayName: "HTTPS Proxy",
    category: "networking",
  },
  google_compute_ssl_certificate: {
    displayName: "SSL Certificate",
    category: "networking",
  },
  google_compute_managed_ssl_certificate: {
    displayName: "Managed SSL Certificate",
    category: "networking",
  },
  google_dns_managed_zone: {
    displayName: "Cloud DNS Zone",
    category: "networking",
  },
  google_dns_record_set: {
    displayName: "DNS Record Set",
    category: "networking",
  },
  google_compute_interconnect_attachment: {
    displayName: "Interconnect Attachment",
    category: "networking",
  },
  google_compute_network_peering: {
    displayName: "VPC Peering",
    category: "networking",
  },
  google_compute_route: {
    displayName: "Network Route",
    category: "networking",
  },
  google_compute_security_policy: {
    displayName: "Cloud Armor Security Policy",
    category: "networking",
  },
  google_network_connectivity_hub: {
    displayName: "Network Connectivity Hub",
    category: "networking",
  },

  // Security
  google_project_iam_member: {
    displayName: "Project IAM Member",
    category: "security",
  },
  google_project_iam_binding: {
    displayName: "Project IAM Binding",
    category: "security",
  },
  google_project_iam_policy: {
    displayName: "Project IAM Policy",
    category: "security",
  },
  google_service_account: {
    displayName: "Service Account",
    category: "security",
  },
  google_service_account_key: {
    displayName: "Service Account Key",
    category: "security",
  },
  google_service_account_iam_member: {
    displayName: "Service Account IAM Member",
    category: "security",
  },
  google_kms_key_ring: {
    displayName: "KMS Key Ring",
    category: "security",
  },
  google_kms_crypto_key: {
    displayName: "KMS Crypto Key",
    category: "security",
  },
  google_kms_crypto_key_iam_member: {
    displayName: "KMS Key IAM Member",
    category: "security",
  },
  google_secret_manager_secret: {
    displayName: "Secret Manager Secret",
    category: "security",
  },
  google_secret_manager_secret_version: {
    displayName: "Secret Manager Version",
    category: "security",
  },
  google_compute_ssl_policy: {
    displayName: "SSL Policy",
    category: "security",
  },
  google_iap_web_iam_member: {
    displayName: "IAP Web IAM Member",
    category: "security",
  },
  google_identity_platform_config: {
    displayName: "Identity Platform Config",
    category: "security",
  },

  // Analytics
  google_bigquery_dataset: {
    displayName: "BigQuery Dataset",
    category: "analytics",
  },
  google_bigquery_table: {
    displayName: "BigQuery Table",
    category: "analytics",
  },
  google_bigquery_job: {
    displayName: "BigQuery Job",
    category: "analytics",
  },
  google_dataflow_job: {
    displayName: "Dataflow Job",
    category: "analytics",
  },
  google_dataproc_cluster: {
    displayName: "Dataproc Cluster",
    category: "analytics",
  },
  google_pubsub_topic: {
    displayName: "Pub/Sub Topic",
    category: "analytics",
  },
  google_pubsub_subscription: {
    displayName: "Pub/Sub Subscription",
    category: "analytics",
  },
  google_composer_environment: {
    displayName: "Cloud Composer Environment",
    category: "analytics",
  },
  google_data_fusion_instance: {
    displayName: "Data Fusion Instance",
    category: "analytics",
  },
  google_datastream_stream: {
    displayName: "Datastream Stream",
    category: "analytics",
  },

  // DevOps
  google_cloudbuild_trigger: {
    displayName: "Cloud Build Trigger",
    category: "devops",
  },
  google_artifact_registry_repository: {
    displayName: "Artifact Registry",
    category: "devops",
  },
  google_container_registry: {
    displayName: "Container Registry",
    category: "devops",
  },
  google_sourcerepo_repository: {
    displayName: "Source Repository",
    category: "devops",
  },
  google_clouddeploy_delivery_pipeline: {
    displayName: "Cloud Deploy Pipeline",
    category: "devops",
  },

  // Monitoring
  google_logging_project_sink: {
    displayName: "Logging Sink (Project)",
    category: "monitoring",
  },
  google_logging_folder_sink: {
    displayName: "Logging Sink (Folder)",
    category: "monitoring",
  },
  google_logging_organization_sink: {
    displayName: "Logging Sink (Organization)",
    category: "monitoring",
  },
  google_monitoring_alert_policy: {
    displayName: "Monitoring Alert Policy",
    category: "monitoring",
  },
  google_monitoring_notification_channel: {
    displayName: "Notification Channel",
    category: "monitoring",
  },
  google_monitoring_dashboard: {
    displayName: "Monitoring Dashboard",
    category: "monitoring",
  },
  google_monitoring_uptime_check_config: {
    displayName: "Uptime Check",
    category: "monitoring",
  },

  // AI/ML
  google_vertex_ai_dataset: {
    displayName: "Vertex AI Dataset",
    category: "ai",
  },
  google_vertex_ai_endpoint: {
    displayName: "Vertex AI Endpoint",
    category: "ai",
  },
  google_vertex_ai_featurestore: {
    displayName: "Vertex AI Featurestore",
    category: "ai",
  },
  google_notebooks_instance: {
    displayName: "Vertex AI Notebooks",
    category: "ai",
  },
  google_ml_engine_model: {
    displayName: "AI Platform Model",
    category: "ai",
  },

  // Management
  google_project: {
    displayName: "GCP Project",
    category: "management",
  },
  google_folder: {
    displayName: "Resource Folder",
    category: "management",
  },
  google_organization_policy: {
    displayName: "Organization Policy",
    category: "management",
  },
  google_project_service: {
    displayName: "Project API Service",
    category: "management",
  },
  google_resource_manager_lien: {
    displayName: "Resource Manager Lien",
    category: "management",
  },

  // Billing
  google_billing_account_iam_member: {
    displayName: "Billing Account IAM Member",
    category: "billing",
  },
  google_billing_budget: {
    displayName: "Billing Budget",
    category: "billing",
  },

  // Other
  google_compute_project_metadata: {
    displayName: "Project Metadata",
    category: "other",
  },
  google_compute_project_metadata_item: {
    displayName: "Project Metadata Item",
    category: "other",
  },
  google_apikeys_key: {
    displayName: "API Key",
    category: "other",
  },
  google_vpc_access_connector: {
    displayName: "VPC Access Connector",
    category: "other",
  },
  google_endpoints_service: {
    displayName: "Cloud Endpoints Service",
    category: "other",
  },
  google_compute_region_backend_service: {
    displayName: "Regional Backend Service",
    category: "other",
  },
  google_compute_target_pool: {
    displayName: "Target Pool",
    category: "other",
  },
  google_compute_instance_iam_member: {
    displayName: "Compute Instance IAM Member",
    category: "other",
  },
  google_folder_iam_member: {
    displayName: "Folder IAM Member",
    category: "other",
  },
  google_organization_iam_member: {
    displayName: "Organization IAM Member",
    category: "other",
  },
};

export const top100Meta = gcpTop100Meta;
export default gcpTop100Meta;
